import React, { useRef, useMemo, useCallback, useEffect } from 'react'
import { AVERAGE_LETTER_WIDTH, MAX_CHARACTERS } from './consts'
import HomeFaq from './HomeFaq'

const faqData = [
  {
    question: 'Why Flip?',
    answer:
      'Because Flip is an e-commerce platform and a social network with a highly engaged shopper base looking to discover new brands and products. Brands get access to millions of new shoppers, access to video reviews & feedback from their customers and tools to boost awareness and sales. All powered by Flip’s personalized experience.',
  },
  {
    question: 'How much does it cost?',
    answer:
      'There is no cost to join or fees for the content generated. Flip gets paid when you get paid. We charge a % fee on all sales generated directly through the platform. The fee is based on your product category.',
  },
  {
    question:
      'How does my brand / products get reviewed and shown in the feed?',
    answer:
      'Products get reviewed on Flip through our Gratis program which seeds the products to the right shoppers. These shoppers create authentic reviews about your products which are then shown in the personalized feed for each shopper. You decide how many units for each product to include in the gratis program. Shoppers who purchase your product can create reviews on Flip as well. Brands are not allowed to incentivize shoppers to post reviews on Flip to preserve authenticity of reviews.   Shoppers earn from video views and sales generated by their reviews.',
  },
  {
    question: 'Can I control how my Brand is showcased on Flip?',
    answer:
      'Yes, you are always in control. Brands have their own completely customizable landing page that can be set up to mirror your brand voice and ethos. All images, product descriptions, SKUs, pricing, promotions, etc. can be updated 24/7 through your MagicOS Dashboard. Your brand page displays all live shoppable products (SKUs), populates all the user-generated content (UGC) tagged with your products, as well as showcases your own generated reviews and tutorials on the app!',
  },
]

const translations = {
  header: 'FAQs',
}

const HomeFaqContainer = () => {
  const refFaq = useRef()
  const widthText = refFaq?.current?.offsetWidth || 700
  const letttersMaxWidth = AVERAGE_LETTER_WIDTH * MAX_CHARACTERS

  const lines = useMemo(() => Math.ceil(letttersMaxWidth / widthText) || 3, [
    refFaq?.current,
  ])

  useEffect(() => {
    if (refFaq?.current) {
      const firstChild = refFaq.current.children[0]
      firstChild.classList.add('active')
    }
  }, [refFaq.current])

  const toggleDetails = useCallback(
    index => {
      const item = refFaq.current.children[index]
      if (item.classList.contains('active')) {
        item.classList.remove('active')
        return
      }
      item.classList.add('active')
    },
    [refFaq.current]
  )

  const props = {
    refFaq,
    faqData,
    lines,
    translations,
    toggleDetails,
  }

  return <HomeFaq {...props} />
}

export default HomeFaqContainer
